import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GlgButton } from 'Shared/components'

import useSessionSaver from '../../hooks/useSessionSaver'
import useCloningStepsActions from '../../hooks/useCloningStepsActions'
import { selectCloningModal, setCloningModal } from '../../reducers/cloning_steps'
import { CloningStepsModals } from '../../constants'
import MissingRenamesModal from './modals/MissingRenamesModal'
import CancelSessionModal from './modals/CancelSessionModal'
import SaveDraftSuccessModal from './modals/SaveDraftSuccessModal'
import SaveDraftErrorModal from './modals/SaveDraftErrorModal'
import OutdatedLeaguesModal from './modals/OutdatedLeaguesModal'

const ModalsMapping = {
  [CloningStepsModals.MISSING_LEAGUES_RENAMES]: <MissingRenamesModal/>,
  [CloningStepsModals.CANCEL_SESSION]: <CancelSessionModal/>,
  [CloningStepsModals.SAVE_DRAFT_SUCCESS]: <SaveDraftSuccessModal/>,
  [CloningStepsModals.SAVE_DRAFT_ERROR]: <SaveDraftErrorModal/>,
  [CloningStepsModals.OUTDATED_LEAGUES]: <OutdatedLeaguesModal/>,
}

const Footer = () => {
  const dispatch = useDispatch()
  const cloningModal = useSelector(selectCloningModal)
  const { saveSessionToServer, isLoading, error } = useSessionSaver()
  const { goToNextCloningStep, goToPrevCloningStep, isLastCloningStep, isNextStepAllowed } = useCloningStepsActions()

  const [ isSavingDraft, setIsSavingDraft ] = useState(false)
  const prevIsLoadingRef = useRef(false)

  useEffect(() => {
    if (prevIsLoadingRef.current && !isLoading && isSavingDraft) {
      setIsSavingDraft(false)
      if (!error) {
        dispatch(setCloningModal(CloningStepsModals.SAVE_DRAFT_SUCCESS))
      } else {
        dispatch(setCloningModal(CloningStepsModals.SAVE_DRAFT_ERROR))
      }
    }
    prevIsLoadingRef.current = isLoading
  }, [ isLoading, isSavingDraft, error, dispatch ])

  const handleSaveAsDraft = () => {
    setIsSavingDraft(true)
    saveSessionToServer()
  }

  return <div className={'cls-footer'}>
    <GlgButton
      text={window.I18n.t('buttons.back')}
      className={'cls-footer-button-dark'}
      disabled={isSavingDraft}
      onClick={() => goToPrevCloningStep()}
    />
    <GlgButton
      text={window.I18n.t('buttons.save_as_draft')}
      className={'cls-footer-button-dark'}
      disabled={isSavingDraft}
      onClick={() => handleSaveAsDraft()}
    />
    <GlgButton
      text={isLastCloningStep ? window.I18n.t('buttons.finish') : window.I18n.t('buttons.continue') }
      className={'cls-footer-button'}
      disabled={!isNextStepAllowed || isSavingDraft}
      onClick={() => goToNextCloningStep()}
    />
    {cloningModal && ModalsMapping[cloningModal]}
  </div>
}

export default Footer
